import React, { useEffect, useState } from 'react'
import { Card, Text, TextField, Button, Modal, InlineStack, BlockStack, InlineGrid, Icon } from '@shopify/polaris'
import { DiscountIcon } from '@shopify/polaris-icons';
import CustomToggle from '../CustomToggle';
import '../FreeShippingRules/style.css'
import { useDispatch, useSelector } from 'react-redux'
import { saveFreeShippingRule } from "../../store/actions/shippingActions";
import AdvancedOptions from '../AdvancedOptions';
import ShopifyDatePicker from '../ShopifyDatePicker';
import './style.css'
import { setToast } from "../../store/actions/configActions";
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';

const FreeShippingSetting = props => {

    const { shop_id, currency } = useSelector(state => state.ConfigReducer)
    const { free_shipping_rule } = useSelector(state => state.ShippingReducer)
    const dispatch = useDispatch()
    const fetchJson = useAuthenticatedFetch()

    const [FreeShippingRule, setFreeShippingRule] = useState({ shop_id: shop_id, active: false })
    const [Schedule, setSchedule] = useState(false)
    const [IsSaving, setIsSaving] = useState(false)
    const [Error, setError] = useState({})
    const [SelectedDates, setSelectedDates] = useState({});

    const { onStateChange } = props
    useEffect(() => {
        if (onStateChange) onStateChange(FreeShippingRule)
    }, [FreeShippingRule, onStateChange])

    useEffect(() => {
        if (shop_id !== '') {
            setFreeShippingRule({ ...FreeShippingRule, shop_id: shop_id })
        }
    }, [shop_id])

    useEffect(() => {
        if (free_shipping_rule.id) {
            const rule = { ...free_shipping_rule }
            if (free_shipping_rule.start && free_shipping_rule.end) {
                rule.start = new Date(free_shipping_rule.start)
                rule.end = new Date(free_shipping_rule.end)
                setSelectedDates({ ...SelectedDates, start: new Date(free_shipping_rule.start), end: new Date(free_shipping_rule.end) })
            }
            setFreeShippingRule({ ...FreeShippingRule, ...rule })
        }

    }, [free_shipping_rule])

    const handleChange = obj => {
        try {
            setFreeShippingRule({ ...FreeShippingRule, ...obj })
        } catch (error) {
            console.log(error.message);
        }
    }
    const saveRule = async () => {
        let isError = false
        if (!FreeShippingRule.name || FreeShippingRule.name === '') {
            isError = true
            setError({ name: 'Required!' })
        } else if (!FreeShippingRule.minSpent || FreeShippingRule.minSpent === '') {
            isError = true
            setError({ minSpent: 'Required!' })
        } else if (FreeShippingRule.minSpent < 0) {
            isError = true
            setError({ minSpent: 'Price must be 0 (Zero) or greater!' })
        } else {
            isError = false
            setError({})
        }

        if (!isError) {
            if (window.navigator.onLine) {

                let start = null, end = null
                if (FreeShippingRule.start && FreeShippingRule.end) {
                    FreeShippingRule.end.setHours(23, 58)
                    start = FreeShippingRule.start.toDateString()
                    end = FreeShippingRule.end.toDateString()
                }
                setIsSaving(true)
                try {
                    const response = await fetchJson(`/settings/free-shipping`, {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ ...FreeShippingRule, start, end, shop_id: shop_id })
                    })
                    if (response?.status === "updated" || response?.status === "created") {
                        const FreeShippingRule = response?.free_shipping_rule
                        dispatch(saveFreeShippingRule(FreeShippingRule))
                        dispatch(setToast({ active: true, content: 'Data have been saved.' }))
                    } else {
                        dispatch(setToast({ active: true, content: response?.status }))
                    }
                } catch (e) {
                    dispatch(setToast({ active: true, content: e.message, error: true }))
                } finally {
                    setIsSaving(false)
                }
            } else {
                dispatch(setToast({ active: true, content: 'Check Your Internet Connection.', error: true }))
            }
        } else {
            dispatch(setToast({ active: true, content: 'Fields are required.', error: true }))
        }
    }
    const blocked = () => dispatch(setToast({ active: true, content: 'This feature is not available in current plan.', error: true }))
    const proSuffix = props.disabled ? ' (Pro)' : ''
    const hasSchedule = FreeShippingRule.start && FreeShippingRule.end

    return (
        <Card>
            <BlockStack gap="400">
                <div className="fs-rule-head">
                    <span className="fs-ico" aria-hidden="true"><Icon source={DiscountIcon} /></span>
                    <span style={{ flexGrow: 1 }}>
                        <BlockStack gap="050">
                            <Text as="h2" variant="headingMd">Free Shipping on Spending{proSuffix}</Text>
                            <Text as="p" tone="subdued">You can also schedule this free shipping.</Text>
                        </BlockStack>
                    </span>
                    <CustomToggle active={Boolean(FreeShippingRule.active)} handleToggle={value => {
                        if (!props.disabled) {
                            handleChange({ "active": value })
                        } else {
                            blocked()
                        }
                    }} />
                </div>

                <div className={`fs-rule-body${FreeShippingRule.active ? '' : ' off'}`}>
                    <BlockStack gap="400">
                        <InlineGrid columns={{ xs: 1, md: 2 }} gap="400">
                            <TextField label="Display Name" type="text" autoComplete="off" error={Error.name} disabled={props.disabled} placeholder={`Enter display name${proSuffix}`} value={FreeShippingRule.name} onChange={value => {
                                if (!props.disabled) {
                                    handleChange({ "name": value })
                                } else {
                                    blocked()
                                }
                            }} />
                            <TextField label="Minimum Spent" type="number" min={0} autoComplete="off" prefix={currency} error={Error.minSpent} disabled={props.disabled} placeholder={`0.00${proSuffix}`} value={FreeShippingRule.minSpent} onChange={value => {
                                if (!props.disabled) {
                                    handleChange({ "minSpent": value })
                                } else {
                                    blocked()
                                }
                            }} />
                        </InlineGrid>
                        <AdvancedOptions codeValue={FreeShippingRule.service_code}
                            handleChange={handleChange}
                            descriptionValue={FreeShippingRule.description}
                            rows={3}
                            chars={FreeShippingRule.description ? FreeShippingRule.description.length : 0}
                            maxChars={255}
                            disabled={props.disabled}
                        />

                        <div className="fs-schedule">
                            {hasSchedule ? (
                                <>
                                    <BlockStack gap="050">
                                        <Text as="span" fontWeight="semibold">Free shipping between these days</Text>
                                        <Text as="span" tone="subdued" numeric>Start: {FreeShippingRule.start.toDateString()} · End: {FreeShippingRule.end.toDateString()}</Text>
                                    </BlockStack>
                                    <InlineStack gap="200">
                                        <Button disabled={props.disabled} onClick={() => {
                                            if (!props.disabled) {
                                                setSchedule(true)
                                            } else {
                                                blocked()
                                            }
                                        }}>Edit</Button>
                                        <Button variant="tertiary" tone="critical" disabled={props.disabled} onClick={() => {
                                            const free = FreeShippingRule;
                                            free.start = null;
                                            free.end = null;
                                            setFreeShippingRule({ ...free })
                                        }}>Remove</Button>
                                    </InlineStack>
                                </>
                            ) : (
                                <>
                                    <BlockStack gap="050">
                                        <Text as="span" fontWeight="semibold">Schedule</Text>
                                        <Text as="span" tone="subdued">Run free shipping only between two dates.</Text>
                                    </BlockStack>
                                    <Button disabled={props.disabled} onClick={() => setSchedule(true)}>Schedule Free Shipping{proSuffix}</Button>
                                </>
                            )}
                        </div>
                    </BlockStack>
                </div>

                <InlineStack align="end">
                    <Button variant='primary' loading={IsSaving} disabled={IsSaving || props.disabled} onClick={() => {
                        if (!props.disabled) {
                            saveRule()
                        } else {
                            blocked()
                        }
                    }} >{free_shipping_rule.id ? 'Update' : 'Save'}</Button>
                </InlineStack>
            </BlockStack>
            <Modal
                open={Schedule}
                onClose={() => {
                    setSchedule(false)
                }}
                title="Select date range for free shipping"
                primaryAction={{
                    content: "Schedule",
                    onAction: () => {
                        setSchedule(false)
                        setFreeShippingRule({ ...FreeShippingRule, ...SelectedDates })
                    },
                }}
                secondaryActions={[
                    {
                        content: "Cancel",
                        destructive: true,
                        onAction: () => {
                            setSchedule(false)
                        },
                    },
                ]}
            >
                <Modal.Section>
                    <ShopifyDatePicker SelectedDates={SelectedDates} setSelectedDates={setSelectedDates} />
                </Modal.Section>
            </Modal>
        </Card>
    )
}

export default FreeShippingSetting
